import Vue from 'vue'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Tooltip from 'element-ui/lib/tooltip'
import Upload from 'element-ui/lib/upload'
import Button from 'element-ui/lib/button'
import Input from 'element-ui/lib/input'
import Table from 'element-ui/lib/table'
import TableColumn from 'element-ui/lib/table-column'
import Tabs from 'element-ui/lib/tabs'
import TabPane from 'element-ui/lib/tab-pane'
import Row from 'element-ui/lib/row'
import Col from 'element-ui/lib/col'
import Container from 'element-ui/lib/container'
import Main from 'element-ui/lib/main'
import Tag from 'element-ui/lib/tag'
import Pagination from 'element-ui/lib/pagination'
import Menu from 'element-ui/lib/menu'
import MenuItem from 'element-ui/lib/menu-item'
import Select from 'element-ui/lib/select'
import Option from 'element-ui/lib/option'
import Form from 'element-ui/lib/form'
import FormItem from 'element-ui/lib/form-item'
import Header from 'element-ui/lib/header'
import Message from 'element-ui/lib/message'
import Alert from 'element-ui/lib/alert'
import CheckBox from 'element-ui/lib/checkbox'
import Progress from 'element-ui/lib/progress'
import '@/styles/element-variables.scss'
import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router from './router'
import formatters from '@/utils/formatters'
import filters from '@/utils/filters'
import envConfig from '@/envConfig/config'
import '@/icons'
import './permission' // permission control
// import * as Sentry from "@sentry/browser";
// import { Vue as VueIntegration } from "@sentry/integrations";
// import { Integrations } from "@sentry/tracing";

// Sentry.init({
//    dsn: "https://70b90415321b40e0bae4be5646621b6a@o480754.ingest.sentry.io/5528906",
//    integrations: [
//      new VueIntegration({
//        Vue,
//        tracing: true,
//      }),
//      new Integrations.BrowserTracing(),
//    ],

//    // We recommend adjusting this value in production, or using tracesSampler
//    // for finer control
//    tracesSampleRate: 1.0,
//  });
Vue.use(Tooltip)
Vue.use(Upload)
Vue.use(Button)
Vue.use(Input)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Container)
Vue.use(Tabs)
Vue.use(Row)
Vue.use(Col)
Vue.use(Main)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Pagination)
Vue.use(Header)
Vue.use(TabPane)
Vue.use(Tag)
Vue.use(Alert)
Vue.use(CheckBox)
Vue.use(Progress)
Vue.use(Select)
Vue.use(Option)
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// Vue.use(Element, {
//   size: Cookies.get('size') || 'medium' // set element-ui default size
// })
Vue.prototype.$message = Message
Vue.prototype.$myFormatters = formatters
Vue.prototype.$environmentSettings = envConfig
console.log('config', envConfig)
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
